<template>
  <HomeSouthAfrica v-if="isZa" />
  <HomeEurope v-else-if="isEu" />
  <HomeUS v-else />
</template>
<script setup lang="ts">
const { isZa, isEu } = useSite()
definePageMeta({
  middleware: ['sosovalue', 'ip2location'],
})
</script>
